import { TFolder } from "../../../models/folder-model";

export const folders: TFolder[] = [
  {
    type: "FOLDER",
    depth: 0,
    matterId: "5b00fed7-368e-4309-bd92-79f47ceaafe2",
    id: "78c32c5e-434e-4688-806b-c15644034f5e",
    parentId: "f69cf4e9-c07c-4cf3-9a96-49f8c1cb95b1",
    name: "Before things get awkward",
    dateCreated: "2024-06-20T08:16:16.527Z",
    dateModified: "2024-06-20T08:16:16.527Z",
    subFolders: [],
  },
  {
    depth: 0,
    type: "FOLDER",
    matterId: "5b00fed7-368e-4309-bd92-79f47ceaafe2",
    id: "78c1d565-6d15-4a9b-b768-c5ecbcce7180",
    parentId: "",
    name: "Damien Rush",
    dateCreated: "2024-06-20T01:57:52.289Z",
    dateModified: "2024-06-20T01:57:52.289Z",
    subFolders: [],
  },
  {
    depth: 0,
    type: "FOLDER",
    matterId: "5b00fed7-368e-4309-bd92-79f47ceaafe2",
    id: "8f0533d4-e5e4-4e14-bb2c-dd19a5fec917",
    parentId: "05abb2a3-2051-41ff-9f71-3a0a082834cc",
    name: "Hates Outlook",
    dateCreated: "2024-06-20T01:58:13.507Z",
    dateModified: "2024-06-20T01:58:13.507Z",
    subFolders: [],
  },
  {
    depth: 0,
    type: "FOLDER",
    matterId: "5b00fed7-368e-4309-bd92-79f47ceaafe2",
    id: "f69cf4e9-c07c-4cf3-9a96-49f8c1cb95b1",
    parentId: "bf47fe6c-dc92-4a00-941d-eb2d13965895",
    name: "How far can we drill down",
    dateCreated: "2024-06-20T08:16:07.654Z",
    dateModified: "2024-06-20T08:16:07.654Z",
    subFolders: [],
  },
  {
    depth: 0,
    type: "FOLDER",
    matterId: "5b00fed7-368e-4309-bd92-79f47ceaafe2",
    id: "4689a224-eaf3-4970-a3b4-248e3f0d09d2",
    parentId: "78c32c5e-434e-4688-806b-c15644034f5e",
    name: "I bet my control will stop working already",
    dateCreated: "2024-06-20T08:16:29.670Z",
    dateModified: "2024-06-20T08:16:29.670Z",
    subFolders: [],
  },
  {
    depth: 0,
    type: "FOLDER",
    matterId: "5b00fed7-368e-4309-bd92-79f47ceaafe2",
    id: "05abb2a3-2051-41ff-9f71-3a0a082834cc",
    parentId: "",
    name: "Leon Zhou",
    dateCreated: "2024-06-20T01:57:32.762Z",
    dateModified: "2024-06-20T01:57:32.762Z",
    subFolders: [],
  },
  {
    depth: 0,
    type: "FOLDER",
    matterId: "5b00fed7-368e-4309-bd92-79f47ceaafe2",
    id: "719bef15-b7df-4213-b3a8-94e205cd2fc8",
    parentId: "05abb2a3-2051-41ff-9f71-3a0a082834cc",
    name: "Loves His Appointments",
    dateCreated: "2024-06-20T01:58:06.579Z",
    dateModified: "2024-06-20T01:58:06.579Z",
    subFolders: [],
  },
  {
    depth: 0,
    type: "FOLDER",
    matterId: "5b00fed7-368e-4309-bd92-79f47ceaafe2",
    id: "bd5c7910-049a-4b0f-ab94-a3c26ffc14ba",
    parentId: "05abb2a3-2051-41ff-9f71-3a0a082834cc",
    name: "Loves His Files",
    dateCreated: "2024-06-20T01:57:59.939Z",
    dateModified: "2024-06-20T01:57:59.939Z",
    subFolders: [],
  },
  {
    depth: 0,
    type: "FOLDER",
    matterId: "5b00fed7-368e-4309-bd92-79f47ceaafe2",
    id: "1da0e030-f00f-4a49-bd34-a5f90ad87f73",
    parentId: "",
    name: "Max Hyde",
    dateCreated: "2024-06-20T01:57:45.664Z",
    dateModified: "2024-06-20T01:57:45.664Z",
    subFolders: [],
  },
  {
    depth: 0,
    type: "FOLDER",
    matterId: "5b00fed7-368e-4309-bd92-79f47ceaafe2",
    id: "896dafbe-71cc-4a14-b7f8-aaf60e0c3255",
    parentId: "78c1d565-6d15-4a9b-b768-c5ecbcce7180",
    name: "My Private Stuff",
    dateCreated: "2024-06-20T02:12:06.200Z",
    dateModified: "2024-06-20T02:12:06.200Z",
    subFolders: [],
  },
  {
    depth: 0,
    type: "FOLDER",
    matterId: "5b00fed7-368e-4309-bd92-79f47ceaafe2",
    id: "9f917acf-dd26-449b-ad51-8c22cf40352c",
    parentId: "1da0e030-f00f-4a49-bd34-a5f90ad87f73",
    name: "New Folder",
    dateCreated: "2024-06-25T01:07:52.951Z",
    dateModified: "2024-06-25T01:07:52.951Z",
    subFolders: [],
  },
  {
    depth: 0,
    type: "FOLDER",
    matterId: "5b00fed7-368e-4309-bd92-79f47ceaafe2",
    id: "783d998c-9a5c-42c5-afe9-83503ae7cffd",
    parentId: "",
    name: "Pradeep Prem Kamal",
    dateCreated: "2024-06-20T01:57:40.143Z",
    dateModified: "2024-06-20T01:57:40.143Z",
    subFolders: [],
  },
  {
    depth: 0,
    type: "FOLDER",
    matterId: "5b00fed7-368e-4309-bd92-79f47ceaafe2",
    id: "bf47fe6c-dc92-4a00-941d-eb2d13965895",
    parentId: "bd5c7910-049a-4b0f-ab94-a3c26ffc14ba",
    name: "Why is this not showing",
    dateCreated: "2024-06-20T08:16:00.216Z",
    dateModified: "2024-06-20T08:16:00.216Z",
    subFolders: [],
  },
];

export default folders;
